module.exports = "<div class=\"item\">\n    <slot></slot>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./src/Slider.vue
// module id = 226
// module chunks = 0